// Supported languages for interviews
export const LANGUAGES = [
  { code: 'ENG', label: 'English' },
  { code: 'ESP', label: 'Spanish' },
  { code: 'FRA', label: 'French' },
  { code: 'DEU', label: 'German' },
  { code: 'ITA', label: 'Italian' },
  { code: 'POR', label: 'Portuguese' },
  { code: 'JPN', label: 'Japanese' },
  { code: 'KOR', label: 'Korean' },
  { code: 'ZHO', label: 'Chinese' },
  { code: 'ARA', label: 'Arabic' },
  { code: 'HIN', label: 'Hindi' },
  { code: 'RUS', label: 'Russian' },
  { code: 'NLD', label: 'Dutch' },
  { code: 'POL', label: 'Polish' },
  { code: 'TUR', label: 'Turkish' },
  { code: 'VIE', label: 'Vietnamese' },
  { code: 'THA', label: 'Thai' },
  { code: 'SWE', label: 'Swedish' },
  { code: 'NOR', label: 'Norwegian' },
  { code: 'DAN', label: 'Danish' },
  { code: 'FIN', label: 'Finnish' },
  { code: 'HEB', label: 'Hebrew' },
  { code: 'IND', label: 'Indonesian' },
  { code: 'CES', label: 'Czech' },
  { code: 'ELL', label: 'Greek' },
  { code: 'RON', label: 'Romanian' },
  { code: 'UKR', label: 'Ukrainian' },
] as const;

export type LanguageCode = typeof LANGUAGES[number]['code'];

// Helper to get language label from code
export function getLanguageLabel(code: string): string {
  const lang = LANGUAGES.find(l => l.code === code);
  return lang?.label || code;
}
